import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class TermsService {
  apiUrl = environment.serverUrl;
  constructor(private httpCliente: HttpClient) {}

  getTerms(codigoEmpresa: number | string) {
    return this.httpCliente.get<{
      Data: {
        TermoResponsabilidade: string;
      };
    }>(`${this.apiUrl}/termoresponsabilidade?codigoEmpresa=${codigoEmpresa}`);
  }
}
